import React from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const CenterModal = ({
  open,
  setOpen,
  title,
  subtitle,
  children,
  width = 'sm',
  showHeader = true,
}) => {
  const widthClasses = {
    sm: 'max-w-xl',
    md: 'max-w-3xl',
    lg: 'max-w-5xl',
    xl: 'max-w-7xl',
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose} className="relative z-[100]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition duration-500 ease-in-out data-[closed]:opacity-0"
      />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
          <DialogPanel
            transition
            className={`pointer-events-auto w-full ${widthClasses[width] || widthClasses.sm} transform rounded-lg bg-white shadow-xl transition duration-300 ease-out data-[closed]:scale-95 data-[closed]:opacity-0`}
          >
            {showHeader ? (
              <div className="border-b border-gray-200 px-4 py-4 sm:px-6">
                <div className="flex items-start justify-between">
                  <div>
                    <DialogTitle className="text-lg font-semibold leading-6 text-gray-900">
                      {title}
                    </DialogTitle>
                    <div className="text-xs text-gray-600">{subtitle}</div>
                  </div>
                  <div className="ml-3 flex h-7 items-center">
                    <button
                      type="button"
                      className="relative rounded-md text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#02ADAD]"
                      onClick={handleClose}
                    >
                      <span className="absolute -inset-2.5" />
                      <span className="sr-only">Close modal</span>
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <DialogTitle className="sr-only">{title}</DialogTitle>
            )}
            <div className="relative p-4">{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}

export default CenterModal
